import { render, staticRenderFns } from "./SortSlide.vue?vue&type=template&id=1eb02749&"
import script from "./SortSlide.vue?vue&type=script&lang=js&"
export * from "./SortSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eb02749')) {
      api.createRecord('1eb02749', component.options)
    } else {
      api.reload('1eb02749', component.options)
    }
    module.hot.accept("./SortSlide.vue?vue&type=template&id=1eb02749&", function () {
      api.rerender('1eb02749', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/components/slides/SortSlide.vue"
export default component.exports